/* Coco Family Birth Flower buy box – with ATC lock + required‑field badge */
(function () {
    var root = document.getElementById('coco-cvb');
    if (!root || root.dataset.cocoInit) return;
    root.dataset.cocoInit = '1';
  
    /* --- data from Liquid (window.CocoVariantPickerData) --- */
    var DATA = window.CocoVariantPickerData || {};
    var FRAMINGS = DATA.framings || [];
    var RUSHES   = DATA.rushes || [];
    var IMG      = { trad: DATA.imgTrad || '', south: DATA.imgSouth || '', name: DATA.imgName || '', fname: DATA.imgFname || DATA.imgName || '' };
    var DRUSH    = DATA.drush || root.dataset.drush || '';
    var VARS     = DATA.variants || [];
    var FAVAIL   = DATA.framingAvailability || [];
    var TITLES   = DATA.titles || {};
  
    var MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];
    var scope = document.querySelector('.product-info') || document;

    /* --- product form: resolved first, because the ATC lookup depends on it --- */
    var pform = (function () {
      var b = document.querySelector('.product-info__buy-buttons button[type="submit"]') ||
              document.querySelector('.product-info buy-buttons button[type="submit"]') ||
              document.querySelector('.product-info button[type="submit"][name="add"]');
      var f = b && b.closest('form[action*="/cart/add"]');
      return f ||
             document.querySelector('.product-info__buy-buttons form[action*="/cart/add"]') ||
             document.querySelector('.product-info form[action*="/cart/add"]') ||
             document.querySelector('form[action*="/cart/add"]');
    })();
  
    /* --- helpers --- */
    function $(s) { return root.querySelector(s); }
    function all(s) { return Array.prototype.slice.call(root.querySelectorAll(s)); }
    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;' }[c]; }); }
  
    /* --- frame option matching --- */
    function findFr(pred) { for (var i = 0; i < FRAMINGS.length; i++) { if (pred(FRAMINGS[i])) return FRAMINGS[i]; } return null; }
    var V = {
      digital: findFr(function (v) { return /no\s*frame|digital/i.test(v); }),
      print3040: findFr(function (v) { return /30\s*x\s*40/i.test(v) && /print|poster|matte/i.test(v); }),
      print4560: findFr(function (v) { return /45\s*x\s*60/i.test(v) && /print|poster|matte/i.test(v); }),
      f3040: {
        oak: findFr(function (v) { return /30\s*x\s*40/i.test(v) && /oak/i.test(v); }),
        white: findFr(function (v) { return /30\s*x\s*40/i.test(v) && /white/i.test(v); }),
        black: findFr(function (v) { return /30\s*x\s*40/i.test(v) && /black/i.test(v); })
      },
      f4560: {
        oak: findFr(function (v) { return /45\s*x\s*60/i.test(v) && /oak/i.test(v); }),
        white: findFr(function (v) { return /45\s*x\s*60/i.test(v) && /white/i.test(v); }),
        black: findFr(function (v) { return /45\s*x\s*60/i.test(v) && /black/i.test(v); })
      }
    };
    var RUSH_ON = null, RUSH_OFF = null;
    RUSHES.forEach(function (r) { if (/48\s*hours/i.test(r)) RUSH_ON = r; else RUSH_OFF = r; });
    function availForFrame(framingVal, rushBool) {
      if (!framingVal) return true;
      for (var i = 0; i < FAVAIL.length; i++) { if (FAVAIL[i].f === framingVal) return FAVAIL[i].a !== false; }
      return true;
    }
  
    /* --- state --- */
    var st = { fin: 'digital', printSize: '3040', col: 'oak', style: '', rush: false,
               members: [{ month: '', name: '' }] };
  
    /* --- drive native BPO selects (Framing & Rush Order) --- */
    function setNative(value) {
      if (!value) return false;
      var applied = false;
  
      var sels = document.querySelectorAll('select');
      for (var i = 0; i < sels.length; i++) {
        var s = sels[i];
        for (var j = 0; j < s.options.length; j++) {
          if (s.options[j].value === value || s.options[j].textContent.replace(/\s+/g, ' ').trim() === value) {
            if (s.selectedIndex !== j) {
              s.selectedIndex = j;
              s.dispatchEvent(new Event('change', { bubbles: true }));
            }
            applied = true;
          }
        }
      }
  
      var rs = document.querySelectorAll('input[type="radio"]');
      for (var k = 0; k < rs.length; k++) {
        var lbl = rs[k].closest('label');
        var t = (lbl ? lbl.textContent : rs[k].value).replace(/\s+/g, ' ').trim();
        if (rs[k].value === value || t === value) {
          if (!rs[k].checked) {
            rs[k].checked = true;
            rs[k].dispatchEvent(new Event('change', { bubbles: true }));
          }
          applied = true;
        }
      }
  
      var bpoSels = document.querySelectorAll('#bcpo select[name="name0"], #bcpo select[name="name1"]');
      for (var x = 0; x < bpoSels.length; x++) {
        var bs = bpoSels[x];
        for (var y = 0; y < bs.options.length; y++) {
          if (bs.options[y].value === value || bs.options[y].textContent.replace(/\s+/g, ' ').trim() === value) {
            if (bs.selectedIndex !== y) {
              bs.selectedIndex = y;
              bs.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
        }
      }
  
      return applied;
    }
  
    function framingValue() {
      if (st.fin === 'digital') return V.digital;
      if (st.fin === 'print') return st.printSize === '4560' ? V.print4560 : V.print3040;
      if (st.fin === 'f3040') return V.f3040[st.col];
      if (st.fin === 'f4560') return V.f4560[st.col];
      return V.digital;
    }
  
    /* ========== BUTTON PRICE UPDATE ========== */
    /* Only ever look inside the cart form / product area, never at an arbitrary
       submit button elsewhere on the page (header search, newsletter, …). */
    function getATCButton() {
      return (pform && (pform.querySelector('button[name="add"]') ||
                        pform.querySelector('button[type="submit"]') ||
                        pform.querySelector('input[type="submit"]'))) ||
             document.querySelector('.product-info button[name="add"]') ||
             document.querySelector('.product-info button[type="submit"]') ||
             document.querySelector('form[action*="/cart/add"] button[name="add"]') ||
             null;
    }

    function norm(v) { return String(v == null ? '' : v).replace(/\s+/g, ' ').trim().toLowerCase(); }
    function rushValue() { return (st.rush ? RUSH_ON : RUSH_OFF) || ''; }

    /* Matching is case/space insensitive, and falls back to the first variant of
       the chosen framing when the rush option cannot be matched — otherwise a
       single missing rush value silently hides the price. */
    function findVariant(framingVal, rushVal) {
      var f = norm(framingVal), r = norm(rushVal), first = null;
      for (var i = 0; i < VARS.length; i++) {
        var v = VARS[i];
        if (norm(v.option1) !== f) continue;
        if (!first) first = v;
        if (!r || norm(v.option2) === r) return v;
      }
      return first;
    }

    function findVariantId(framingVal, rushVal) {
      var v = findVariant(framingVal, rushVal);
      return v ? v.id : null;
    }

    function updateATCPrice() {
      var variant = findVariant(framingValue(), rushValue());
      if (!variant) return;
  
      var addBtn = getATCButton();
      if (!addBtn) return;
  
      var sym = (DATA.currencySymbol || 'Tk').replace(/<[^>]*>/g, '').trim();
      
      var formatMoney = function(cents) {
        var num = (cents / 100).toFixed(2);
        var parts = num.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return sym + parts.join('.');
      };
  
      var priceCents = variant.price;
      var compareCents = variant.compare_at_price || null;
  
      var lbl = addBtn.querySelector('.coco-btn-price');
      if (!lbl) {
        lbl = document.createElement('span');
        lbl.className = 'coco-btn-price';
        addBtn.appendChild(lbl);
      }
      /* Written only when it actually changes, so the buy-area observer below
         cannot bounce off our own DOM writes. */
      var priceHtml = '<span class="bp-cur">' + formatMoney(priceCents) + '</span>' +
                      (compareCents && compareCents > priceCents
                        ? ' <span class="bp-was">' + formatMoney(compareCents) + '</span>'
                        : '');
      if (lbl.innerHTML !== priceHtml) lbl.innerHTML = priceHtml;
  
      var saveEl = document.getElementById('coco-atc-savings');
      if (!saveEl) {
        saveEl = document.createElement('div');
        saveEl.id = 'coco-atc-savings';
        var container = addBtn.closest('buy-buttons') || addBtn.closest('.product-info__buy-buttons') || addBtn.parentElement;
        if (container) {
          container.parentNode.insertBefore(saveEl, container.nextSibling);
        } else {
          addBtn.parentNode.insertBefore(saveEl, addBtn.nextSibling);
        }
      }
  
      if (compareCents && compareCents > priceCents) {
        var saved = compareCents - priceCents;
        var pct = Math.round((saved / compareCents) * 100);
        var saveHtml = 'You save <strong>' + formatMoney(saved) + '</strong> (' + pct + '%) today';
        saveEl.style.display = 'block';
        if (saveEl.innerHTML !== saveHtml) saveEl.innerHTML = saveHtml;
        addBtn.classList.add('has-savings');
      } else {
        saveEl.style.display = 'none';
        if (saveEl.innerHTML !== '') saveEl.innerHTML = '';
        addBtn.classList.remove('has-savings');
      }
    }
  
    /* The buy buttons can be rendered after this script runs, so keep looking
       until the real button exists rather than pricing whatever is there. */
    function initPrice() {
      if (getATCButton()) {
        updateATCPrice();
        updateATCButtonState();
      } else {
        setTimeout(initPrice, 50);
      }
    }
  
    function applyVariant() {
      setNative(framingValue());
      setNative(rushValue());

      var variantId = findVariantId(framingValue(), rushValue());
      if (variantId && pform) {
        var idInput = pform.querySelector('select[name="id"]') ||
                      pform.querySelector('input[name="id"]');
        if (idInput) {
          if (idInput.tagName === 'SELECT') {
            for (var i = 0; i < idInput.options.length; i++) {
              if (idInput.options[i].value == variantId) {
                if (idInput.selectedIndex !== i) {
                  idInput.selectedIndex = i;
                  idInput.dispatchEvent(new Event('change', { bubbles: true }));
                }
                break;
              }
            }
          } else {
            idInput.value = variantId;
            idInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      }
  
      updateATCPrice();
    }
  
    /* --- BPO text inputs --- */
    function bpoInput(propName) {
      return document.querySelector('input[name="properties[' + propName.replace(/"/g, '\\"') + ']"]');
    }
  
    var K_STYLE   = "Do you want Traditional birth flowers or Southern Hemisphere birth flowers?";
    var K_MEMBERS = "Please leave each family member's birth month (with name if desired)";
    var K_FAMILY  = "Family Name (please put n/a if you don't want a name)";
    var K_NOTE    = "Leave any notes here for our artist in regards to the placement of the flowers (ie Mum in centre)";
  
    function updateProps() {
      var memInput = bpoInput(K_MEMBERS);
      var memStr = st.members.filter(function (m) { return m.month; })
        .map(function (m) { return m.month + (m.name ? ' (' + m.name + ')' : ''); }).join(', ');
      if (memInput) {
        memInput.value = memStr;
        memInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
  
      var famInput = bpoInput(K_FAMILY);
      if (famInput) {
        var fam = ($('#cf-tFam') && $('#cf-tFam').checked && $('#cf-famName').value.trim())
                    ? $('#cf-famName').value.trim() : 'n/a';
        famInput.value = fam;
        famInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
  
      var noteInput = bpoInput(K_NOTE);
      if (noteInput) {
        var note = ($('#cf-tNote') && $('#cf-tNote').checked && $('#cf-note').value.trim())
                     ? $('#cf-note').value.trim() : '';
        noteInput.value = note;
        noteInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  
    function updateFinishUI() {
      all('#cf-finish .cf-opt').forEach(function (opt) {
        opt.classList.toggle('act', opt.getAttribute('data-fin') === st.fin && !opt.classList.contains('cf-soldout'));
      });
      $('#cf-print-sizes').style.display = st.fin === 'print' ? '' : 'none';
      $('#cf-frame3040-colours').style.display = st.fin === 'f3040' ? '' : 'none';
      $('#cf-frame4560-colours').style.display = st.fin === 'f4560' ? '' : 'none';
  
      all('#cf-print-sizes .cf-cc').forEach(function (cc) {
        cc.classList.toggle('act', st.printSize === cc.getAttribute('data-ps') && !cc.classList.contains('cf-soldout'));
      });
      all('#cf-frame3040-colours .cf-cc, #cf-frame4560-colours .cf-cc').forEach(function (cc) {
        cc.classList.toggle('act', st.col === cc.getAttribute('data-col') && !cc.classList.contains('cf-soldout'));
      });
    }
  
    function buildMembers() {
      var container = $('#cf-members');
      if (!container) return;
      container.innerHTML = st.members.map(function (m, i) {
        var opts = '<option value="">Birth month</option>' + MONTHS.map(function (mo) { return '<option ' + (m.month === mo ? 'selected' : '') + '>' + mo + '</option>'; }).join('');
        var rm = st.members.length > 1 ? '<button type="button" class="cf-rm" data-i="' + i + '" aria-label="Remove">×</button>' : '';
        return '<div class="cf-member"><div class="cf-mr"><div style="flex:1"><label>Birth month <span class="cf-rq">· required</span></label><select data-i="' + i + '">' + opts + '</select></div><div style="flex:1"><label>Name <span style="color:var(--coco-bx-subtext,#8a857d);font-weight:400">· optional</span></label><input type="text" data-ni="' + i + '" value="' + esc(m.name) + '" placeholder="e.g. Mum"></div>' + rm + '</div></div>';
      }).join('');
  
      all('#cf-members select').forEach(function (s) { s.addEventListener('change', function () { st.members[+s.getAttribute('data-i')].month = s.value; s.classList.remove('cf-err'); updateProps(); updateCount(); checkATCState(); }); });
      all('#cf-members input[data-ni]').forEach(function (n) { n.addEventListener('input', function () { st.members[+n.getAttribute('data-ni')].name = n.value; updateProps(); }); });
      all('#cf-members .cf-rm').forEach(function (b) { b.addEventListener('click', function () { st.members.splice(+b.getAttribute('data-i'), 1); buildMembers(); updateProps(); updateCount(); checkATCState(); }); });
    }
  
    function updateCount() {
      var c = st.members.filter(function (m) { return m.month; }).length;
      var cntEl = $('#cf-count');
      if (cntEl) cntEl.textContent = c > 0 ? c + (c === 1 ? ' flower' : ' flowers') + ' selected' : '';
    }
  
    function rebuild() { updateFinishUI(); }
    function apply() { applyVariant(); updateProps(); }
  
    /* ========== ATC BUTTON LOCK & MISSING‑FIELD BADGE ========== */
    var submitAttempted = false;
  
    // required‑field check for the family product
    function areFamilyFieldsValid() {
      if (!st.style) {
        return false;
      }
      var selects = all('#cf-members select');
      for (var i = 0; i < selects.length; i++) {
        if (!selects[i].value || selects[i].value.trim() === '') {
          return false;
        }
      }
      return true;
    }
  
    function getMissingFieldsEl() {
      var el = document.getElementById('coco-missing-fields');
      if (!el) {
        el = document.createElement('div');
        el.id = 'coco-missing-fields';
  
        // Insert after the rush section (the last element in the customiser)
        var rushSection = document.querySelector('.cf-rushsec');
        if (rushSection && rushSection.parentNode) {
          rushSection.parentNode.insertBefore(el, rushSection.nextSibling);
        } else {
          // fallback – after the members section or add‑button row
          var membersContainer = $('#cf-members');
          var addBtnRow = $('#cf-addBtn')?.closest('.cf-mem-actions');
          var insertAfter = membersContainer || addBtnRow;
          if (insertAfter && insertAfter.parentNode) {
            insertAfter.parentNode.insertBefore(el, insertAfter.nextSibling);
          } else {
            document.body.appendChild(el);
          }
        }
      }
      return el;
    }
  
    /* Locking goes through one idempotent setter so our own attribute writes,
       the theme's re-renders and the observer below can never disagree.
       We only re-enable a button we disabled ourselves (marked with
       data-coco-locked), so a theme-owned disabled state — sold out, or a
       button that is still hydrating — is left alone. */
    function setBtnLocked(btn, locked) {
      if (locked) {
        if (!btn.disabled && !btn.hasAttribute('disabled')) btn.dataset.cocoLocked = '1';
        btn.disabled = true;
        btn.setAttribute('disabled', '');
        btn.classList.add('coco-atc-locked');
        btn.addEventListener('click', interceptClick, true);
      } else {
        btn.classList.remove('coco-atc-locked');
        btn.removeEventListener('click', interceptClick, true);
        if (btn.dataset.cocoLocked === '1') {
          delete btn.dataset.cocoLocked;
          btn.disabled = false;
          btn.removeAttribute('disabled');
        }
      }
    }

    function isBtnLocked(btn) {
      return btn.disabled || btn.hasAttribute('disabled') || btn.classList.contains('coco-atc-locked');
    }

    function updateATCButtonState() {
      var btn = getATCButton();
      if (!btn) return;
      var valid = areFamilyFieldsValid();

      if (valid !== !isBtnLocked(btn)) setBtnLocked(btn, !valid);

      // build badge message
      var missing = [];
      if (!st.style) missing.push('a birth flower style');
      for (var i = 0; i < st.members.length; i++) {
        if (!st.members[i].month) {
          missing.push('a birth month for each family member');
          break; // only mention once
        }
      }
  
      var msgEl = getMissingFieldsEl();
      if ((submitAttempted || st.style) && missing.length > 0) {
        msgEl.innerHTML = '⚠️ Before we can add this to your cart, please choose ' + missing.join(' and ') + '.';
        msgEl.classList.add('visible');
      } else {
        msgEl.classList.remove('visible');
      }
    }
  
    function interceptClick(e) {
      if (!areFamilyFieldsValid()) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        submitAttempted = true;
        all('#cf-members select').forEach(function(sel){
          if (!sel.value) {
            sel.classList.add('cf-err');
          }
        });
        updateATCButtonState();
        return false;
      }
    }
  
    // Re‑usable check to call on relevant changes (style, member select)
    function checkATCState() {
      updateATCButtonState();
    }
  
    // initial lock
    (function disableButtonInitially() {
      // also lock clicks on the buy‑wrapper
      var buyWrapper = document.querySelector('.product-info buy-buttons');
      if (buyWrapper) {
        buyWrapper.addEventListener('click', function(e) {
          if (areFamilyFieldsValid()) return;
          var btn = getATCButton();
          if (btn && isBtnLocked(btn)) {
            e.preventDefault();
            e.stopPropagation();
            submitAttempted = true;
            updateATCButtonState();
          }
        }, true);
      }

      function buyArea() {
        var btn = getATCButton();
        return (btn && (btn.closest('buy-buttons') || btn.closest('.product-info__buy-buttons') || btn.parentElement)) ||
               document.querySelector('.product-info__buy-buttons') ||
               document.querySelector('.product-info buy-buttons') ||
               pform;
      }

      /* Themes re-render the buy buttons on variant change, which throws away
         our lock and our listeners. Re-apply the state whenever that happens
         instead of force-disabling the button on a timer. */
      function watchBuyArea() {
        var area = buyArea();
        if (!area || area.dataset.cocoBuyWatch === '1') return;
        area.dataset.cocoBuyWatch = '1';
        var queued = false;
        new MutationObserver(function () {
          if (queued) return;
          queued = true;
          requestAnimationFrame(function () {
            queued = false;
            updateATCButtonState();
            updateATCPrice();
          });
        }).observe(area, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'class'] });
      }

      function disable() {
        var btn = getATCButton();
        if (!btn) { setTimeout(disable, 50); return; }
        setBtnLocked(btn, !areFamilyFieldsValid());
        watchBuyArea();
      }

      disable();
    })();
  
    /* ========== EVENTS ========== */
    all('#cf-finish .cf-opt').forEach(function (opt) {
      opt.addEventListener('click', function () {
        if (opt.classList.contains('cf-soldout')) return;
        st.fin = opt.getAttribute('data-fin');
        if (st.fin === 'print' && st.printSize == null) st.printSize = '3040';
        rebuild(); apply();
      });
    });
  
    ['#cf-print-sizes', '#cf-frame3040-colours', '#cf-frame4560-colours'].forEach(function (id) {
      var el = document.querySelector(id); if (!el) return;
      el.addEventListener('click', function (e) {
        var target = e.target.closest('.cf-cc');
        if (!target || target.classList.contains('cf-soldout')) return;
        if (target.hasAttribute('data-col')) st.col = target.getAttribute('data-col');
        if (target.hasAttribute('data-ps')) st.printSize = target.getAttribute('data-ps');
        rebuild(); apply();
      });
    });
  
    buildMembers(); updateCount();
  
    all('.cf-he').forEach(function (e) {
      e.addEventListener('click', function () { setStyle(e.getAttribute('data-style')); });
    });
    function setStyle(s) {
      st.style = s;
      all('.cf-he').forEach(function (x) {
        x.classList.toggle('act', x.getAttribute('data-style') === s);
        x.classList.remove('cf-err');
      });
      var err = $('#cf-styleErr'); if (err) err.style.display = 'none';
      checkATCState();
  
      var radios = document.querySelectorAll('input[name="properties[' + K_STYLE.replace(/"/g, '\\"') + ']"]');
      radios.forEach(function (r) {
        r.checked = (r.value === s);
        r.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  
    $('#cf-tFam').addEventListener('change', function () { $('#cf-famBody').classList.toggle('open', this.checked); updateProps(); });
    $('#cf-tNote').addEventListener('change', function () { $('#cf-noteBody').classList.toggle('open', this.checked); updateProps(); });
    $('#cf-famName').addEventListener('input', updateProps);
    $('#cf-note').addEventListener('input', updateProps);
    $('#cf-addBtn').addEventListener('click', function () {
      st.members.push({ month: '', name: '' }); buildMembers(); updateProps();
      checkATCState();
      var ms = root.querySelector('.cf-memscroll'); if (ms) ms.scrollTop = ms.scrollHeight;
    });
  
    if ($('#cf-rushpr') && DRUSH) {
      var n = parseFloat(String(DRUSH).replace(/[^0-9.,]/g, '').replace(/,(?=\d{3}\b)/g, '').replace(',', '.'));
      var sym = (String(DRUSH).replace(/<[^>]*>/g, '').match(/^[^\d.,\s]+/) || ['$'])[0];
      $('#cf-rushpr').textContent = isFinite(n) ? '+' + sym + Math.round(n) : '';
    }
    $('#cf-rush').addEventListener('click', function () {
      st.rush = !st.rush; $('#cf-rush').classList.toggle('act', st.rush); rebuild(); apply();
    });
  
    function modal(id) { var d = document.getElementById(id); if (d) { d.classList.add('open'); document.body.style.overflow = 'hidden'; } }
    function closeModals() { Array.prototype.forEach.call(document.querySelectorAll('.cf-ov'), function (o) { o.classList.remove('open'); }); document.body.style.overflow = ''; }
    buildStyleModal();
    $('#cf-styleBtn').addEventListener('click', function () { modal('cf-ov-style'); });
    if ($('#cf-namesBtn')) $('#cf-namesBtn').addEventListener('click', function () { modal('cf-ov-name'); });
    if ($('#cf-famExBtn')) $('#cf-famExBtn').addEventListener('click', function () { modal('cf-ov-fname'); });
  
    function buildStyleModal() {
      var trad = IMG.trad ? '<img src="' + IMG.trad + '" alt="Traditional">' : '<div style="padding:30px;color:#9a8b78">Traditional chart</div>';
      var south = IMG.south ? '<img src="' + IMG.south + '" alt="Southern">' : '<div style="padding:30px;color:#9a8b78">Southern chart</div>';
      var nameImg = IMG.name ? '<img src="' + IMG.name + '" alt="Name example" style="width:100%;display:block;border-radius:10px">' : '<div style="padding:34px;text-align:center;color:#9a8b78;background:#f4efe6;border-radius:10px">Coming soon</div>';
      var fnameImg = IMG.fname ? '<img src="' + IMG.fname + '" alt="Family name example" style="width:100%;display:block;border-radius:10px">' : '<div style="padding:34px;text-align:center;color:#9a8b78;background:#f4efe6;border-radius:10px">Coming soon</div>';
      var ov = document.createElement('div'); ov.id = 'cf-ov-style'; ov.className = 'cf-ov';
      ov.innerHTML = '<div class="cf-modal"><button type="button" class="cf-x" aria-label="Close">×</button><h3>Which birth flower style?</h3><p class="cf-cap">Pick the set that matches where your family lives — the flowers for each month differ. Tap one to select it.</p><div class="cf-grid"><div class="cf-exam" data-style="Traditional">' + trad + '<div class="cap2">Traditional</div></div><div class="cf-exam" data-style="Southern Hemisphere">' + south + '<div class="cap2">Southern hemisphere</div></div></div></div>';
      document.body.appendChild(ov);
      var ovn = document.createElement('div'); ovn.id = 'cf-ov-name'; ovn.className = 'cf-ov';
      ovn.innerHTML = '<div class="cf-modal"><button type="button" class="cf-x" aria-label="Close">×</button><h3>Family name example</h3><p class="cf-cap">How the family name and member names appear on the artwork.</p>' + nameImg + '</div>';
      document.body.appendChild(ovn);
      var ovf = document.createElement('div'); ovf.id = 'cf-ov-fname'; ovf.className = 'cf-ov';
      ovf.innerHTML = '<div class="cf-modal"><button type="button" class="cf-x" aria-label="Close">×</button><h3>Family name example</h3><p class="cf-cap">How the family name and member names appear on the artwork.</p>' + fnameImg + '</div>';
      document.body.appendChild(ovf);
      [ov, ovn, ovf].forEach(function (o) {
        o.addEventListener('click', function (e) { if (e.target === o || e.target.classList.contains('cf-x')) closeModals(); });
        Array.prototype.forEach.call(o.querySelectorAll('.cf-exam'), function (ex) { ex.addEventListener('click', function () { setStyle(ex.getAttribute('data-style')); closeModals(); }); });
      });
    }
  
    if (pform) {
      pform.addEventListener('submit', function (e) {
        var bad = false;
        if (!st.style) {
          var err = $('#cf-styleErr'); if (err) err.style.display = 'block';
          all('.cf-he').forEach(function (x) { x.classList.add('cf-err'); }); bad = true;
        }
        st.members.forEach(function (m, i) {
          var sel = all('#cf-members select')[i];
          if (!m.month) { if (sel) sel.classList.add('cf-err'); bad = true; }
        });
        if (bad) {
          e.preventDefault();
          e.stopPropagation();
          root.scrollIntoView({ behavior: 'smooth', block: 'center' });
          // Show the badge after first failed submit
          submitAttempted = true;
          updateATCButtonState();
        }
      }, true);
    }
  
      /* ========== INITIAL SETUP ========== */
      updateFinishUI();
      updateProps();
      updateCount();
  
      // Button starts locked, but badge is hidden until first failed click/submit
      updateATCButtonState();
  
    // Helper: convert a variant's option1 (framing) and option2 (rush) back to our state
    function setStateFromVariant(framingVal, rushVal) {
      // framing
      if (framingVal === V.digital) {
        st.fin = 'digital';
      } else if (framingVal === V.print3040) {
        st.fin = 'print';
        st.printSize = '3040';
      } else if (framingVal === V.print4560) {
        st.fin = 'print';
        st.printSize = '4560';
      } else if (framingVal === V.f3040.oak) {
        st.fin = 'f3040'; st.col = 'oak';
      } else if (framingVal === V.f3040.white) {
        st.fin = 'f3040'; st.col = 'white';
      } else if (framingVal === V.f3040.black) {
        st.fin = 'f3040'; st.col = 'black';
      } else if (framingVal === V.f4560.oak) {
        st.fin = 'f4560'; st.col = 'oak';
      } else if (framingVal === V.f4560.white) {
        st.fin = 'f4560'; st.col = 'white';
      } else if (framingVal === V.f4560.black) {
        st.fin = 'f4560'; st.col = 'black';
      }
      // rush
      st.rush = (rushVal && rushVal.toLowerCase() === RUSH_ON?.toLowerCase()) ? true : false;
    }
  
    // Initialise by respecting the currently selected variant (e.g. from URL)
    (function initialSyncFromExistingVariant() {
      // try to find the active variant ID
      var variantId = null;
      if (pform) {
        var idInput = pform.querySelector('select[name="id"], input[name="id"]');
        if (idInput) {
          variantId = idInput.tagName === 'SELECT' ? idInput.value : idInput.value;
        }
      }
      // if we got a valid variant ID, look it up
      if (variantId) {
        for (var i = 0; i < VARS.length; i++) {
          var v = VARS[i];
          if (String(v.id) === String(variantId)) {
            setStateFromVariant(v.option1, v.option2);
            break;
          }
        }
      }
      // update UI and native selects to match the (possibly newly set) state
      updateFinishUI();
      // Also update rush button visual state
      var rushBtn = $('#cf-rush');
      if (rushBtn) {
        rushBtn.classList.toggle('act', st.rush);
      }
      setNative(framingValue());
      setNative(rushValue());
      // also ensure the hidden ID input is correct (though it already is)
      if (variantId && pform) {
        var idInput = pform.querySelector('select[name="id"], input[name="id"]');
        if (idInput) {
          if (idInput.tagName === 'SELECT') {
            for (var j = 0; j < idInput.options.length; j++) {
              if (idInput.options[j].value == variantId) {
                idInput.selectedIndex = j;
                break;
              }
            }
          } else {
            idInput.value = variantId;
          }
        }
      }
      // after state is restored, update price and check ATC lock
      initPrice();
      checkATCState();
    })();
  
  })();
  
  // Sticky bar handler (unchanged)
  (function () {
    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest && e.target.closest('#foxdos_atc_button_trigger');
      if (!t) return;
      var box = document.getElementById('coco-cvb');
      if (!box) return;
      var r = box.getBoundingClientRect();
      if (r.top < 0 || r.bottom > (window.innerHeight || 800)) {
        e.preventDefault(); e.stopPropagation();
        setTimeout(function () { try { box.scrollIntoView({ block: 'start' }); } catch (_x) {} }, 20);
      }
    }, true);
  })();